export default __webpack_public_path__ + "static/media/video.6e40e58d.mp4";